// Hàng thẻ số liệu đầu tab Thống kê: hôm nay so với hôm qua + người tham gia.
import { Col, Row } from "antd";
import { faCalendarCheck, faCoins, faListCheck, faUsers } from "@fortawesome/free-solid-svg-icons";
import XuKpiCard from "./xu-kpi-card";
import { fmtNum } from "./xu-format-helpers";

const doneCount = (day) => Object.values(day.missions).reduce((s, m) => s + m.completed, 0);

export default function XuStatsKpiRow({ stats, overview }) {
    const { today, yesterday } = stats.todayVsYesterday;
    const act = overview?.active;
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} xl={6}>
                <XuKpiCard icon={faCalendarCheck} tone="emerald" title="Người điểm danh hôm nay" value={fmtNum(today.checkins)}
                    delta={{ now: today.checkins, before: yesterday.checkins }} />
            </Col>
            <Col xs={24} sm={12} xl={6}>
                <XuKpiCard icon={faCoins} tone="amber" title="Xu đã phát hôm nay" value={fmtNum(today.earned)} unit="Xu"
                    delta={{ now: today.earned, before: yesterday.earned }} />
            </Col>
            <Col xs={24} sm={12} xl={6}>
                <XuKpiCard icon={faListCheck} tone="indigo" title="Nhiệm vụ hoàn thành hôm nay" value={fmtNum(doneCount(today))}
                    delta={{ now: doneCount(today), before: doneCount(yesterday) }} />
            </Col>
            <Col xs={24} sm={12} xl={6}>
                <XuKpiCard icon={faUsers} tone="cyan" title="Người tham gia (đã có ví Xu)" value={fmtNum(overview ? overview.participants : stats.walletUsers)}
                    sub={act ? `Có nhận Xu: hôm nay ${fmtNum(act.today)} · 7 ngày ${fmtNum(act.d7)} · 30 ngày ${fmtNum(act.d30)}` : undefined}
                    help="Người tham gia = người đã từng nhận Xu. Người hoạt động = có nhận Xu trong khoảng đó." />
            </Col>
        </Row>
    );
}
